<template>
    <div class="mt-4 mb-2 ">
        <div class="layout row mb-2 ml-3">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.date | time }}</div>
        </div>

        <div class="layout row mb-2 ml-3" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <vue-good-table
            class="schedule-detail-list"
            style="width: 92%; margin-left: 16px;"
            styleClass="vgt-table striped"
            :columns="detailsColumns"
            :rows="details"
            v-if="details && details.length"
            :search-options="{
                enabled: false,
            }"
        >
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.isIcon" class="px-0">
                    <v-icon
                        class="px-0"
                        dark
                        :color="
                            props.column.iconColor(
                                props.row[props.column.field]
                            )
                        "
                        >{{
                            props.column.icon(props.row[props.column.field])
                        }}</v-icon
                    >
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            details: [],

            detailsColumns: [
                {
                    sortable: true,
                    field: "status",
                    hidden: false,
                    isIcon: true,
                    icon: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "mdi-alert-circle";

                        switch (value.toUpperCase()) {
                            case "PROCESSED":
                                return "mdi-check-circle";
                            case "SCHEDULED":
                                return "mdi-clock";
                            case "VOIDED":
                                return "mdi-cancel";
                            case "DECLINED":
                                return "mdi-alert";
                            case "ERROR":
                                return "mdi-alert-circle";
                            case "CANCELED":
                                return "mdi-close-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "#f35123";

                        switch (value.toUpperCase()) {
                            case "PROCESSED":
                                return "success";
                            case "SCHEDULED":
                                return "#fdb400";
                            case "DECLINED":
                            case "ERROR":
                                return "#f35123";
                            case "CANCELED":
                            case "VOIDED":
                                return "#aeb8bf";
                            default:
                                return "";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "date",
                    hidden: false,
                    type: "date",
                    width: "100px",
                    dateOutputFormat: "MM/DD/YYYY",
                },
                {
                    sortable: true,
                    label: "Amount",
                    field: "amount",
                    type: "decimal",
                    width: "100px",
                    hidden: false,
                    formatFn: (value) => formatCurrency(value),
                },
                {
                    sortable: true,
                    label: "Status",
                    field: "status",
                    width: "100px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Type",
                    field: "type",
                    width: "100px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Paid",
                    field: "isPaid",
                    type: "boolean",
                    width: "60px",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Payment Date",
                    field: "paymentDate",
                    hidden: false,
                    type: "date",
                    width: "100px",
                    dateOutputFormat: "MM/DD/YYYY",
                },
                {
                    sortable: false,
                    label: "Read",
                    field: "read",
                    type: "boolean",
                    width: "60px",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Notified",
                    field: "notified",
                    type: "boolean",
                    width: "60px",
                    formatFn: (value) => (value ? "Yes" : "No"),
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Notes",
                    field: "note",
                    width: "300px",
                    hidden: false,
                },
            ],
        };
    },
    async created() {
        this.loadDetails();
    },
    computed: {},
    methods: {
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "enteredOn",
                    "date"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async loadDetails() {
            if (!this.row.callUUID) return;

            const details = await this.$http.get(
                "api/tips/getByCallUUID?callUUID=" + this.row.callUUID
            );

            this.details = details;
        },
    },
};
</script>
<style>
.schedule-detail-list .vgt-table {
    border: 1px solid #ddd !important;
}

.schedule-detail-list table.vgt-table td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    padding-left: 8px !important;
    font-weight: 400 !important;
}

.schedule-detail-list tr:nth-child(even) {
    background-color: #fff !important;
}
</style>
